import { IconUser } from '@calendly/ui/components/glyphs/IconUser'
import { UiIcon } from '@calendly/ui/components/ui-icon'
import { DetailsItem as Item } from '@calendly/booking-kit'

export default ({ name, bookingAppRedesign = false }) => (
  <Item>
    <UiIcon icon={IconUser} size={bookingAppRedesign ? 'small' : 'medium'} spacingRight="8" data-id="details-item-icon" />
    {name}
  </Item>
)
